import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ChatRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const companyId = localStorage.getItem("company_id");
    const tokenTimeRaw = localStorage.getItem("TokenTime");
    const tokenTime = Number(tokenTimeRaw);

    const isLogin =
      !!companyId &&
      !!tokenTimeRaw &&
      !Number.isNaN(tokenTime) &&
      Date.now() <= tokenTime;

    if (!isLogin) {
      navigate("/Login", { replace: true });
      return;
    }

    const deviceType = (localStorage.getItem("deviceType") || "P").toUpperCase(); // 'M'|'T'|'P'

    if (deviceType === "M") {
      navigate("/m/chat", { replace: true });
      return;
    }
    // 태블릿 라우트 없으면 PC로
    navigate("/p/chat", { replace: true });
  }, [navigate]);

  return null;
}
